import { localizePath, stripLocalePrefix } from "@/lib/localeRoutes";

export const ANTALYA_DESTINATIONS = [
  { slug: "belek" },
  { slug: "lara" },
  { slug: "kemer" },
  { slug: "side" },
  { slug: "alanya" },
  { slug: "kas" },
  { slug: "kalkan" },
] as const;

export type AntalyaDestinationSlug =
  (typeof ANTALYA_DESTINATIONS)[number]["slug"];

const DESTINATION_SLUGS = new Set<string>(
  ANTALYA_DESTINATIONS.map(({ slug }) => slug),
);

export function antalyaHubPath(locale: string): string {
  return localizePath("/locations/antalya", locale);
}

export function antalyaDestinationPath(
  slug: AntalyaDestinationSlug,
  locale: string,
): string {
  return localizePath(`/locations/antalya/${slug}`, locale);
}

export function resolveAntalyaDestination(
  pathname: string,
): AntalyaDestinationSlug | null {
  const segments = stripLocalePrefix(pathname).split("/").filter(Boolean);

  if (
    segments.length !== 3 ||
    segments[0] !== "locations" ||
    segments[1] !== "antalya" ||
    !DESTINATION_SLUGS.has(segments[2])
  ) {
    return null;
  }

  return segments[2] as AntalyaDestinationSlug;
}
